import { 
	call, 
	put, 
	takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Store from "../../Store/Store";

export default function* unfinishedTasksCount(action: ActionInterface): any {
  try {
    let request = "events?first_item=0&last_item=0&event_type_ids=35,38&removed=0&reacted=0&is_snoozed=0";
    
    if (!Store.getConfigurator().getState().app?.settings?.agency?.isActivitiesShown) {
      request = request + "&refers_to_event_id=";
    }
 
    const res = yield call(Http.get, request);

    yield put({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST_SUCCESS,
      payload: {
        unfinishedTasksEventsCount: res.data.events.count
      }
    });

    yield put({
      type: Constants.GLOBAL_UNFINISHED_TASKS_COUNT_SUCCESS
    });
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchUnfinishedTasksCount() {
  yield takeEvery(Constants.GLOBAL_UNFINISHED_TASKS_COUNT, unfinishedTasksCount);
}
